var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 1.16699C3.77935 1.16699 1.16602 3.78033 1.16602 7.00033C1.16602 10.2203 3.77935 12.8337 6.99935 12.8337C10.2193 12.8337 12.8327 10.2203 12.8327 7.00033C12.8327 3.78033 10.2193 1.16699 6.99935 1.16699ZM5.83268 9.91699L2.91602 7.00033L3.73852 6.17783L5.83268 8.26616L10.2602 3.83866L11.0827 4.66699L5.83268 9.91699Z",
    fill: "#38A236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.0a6fd38d22676f13cbcae91eb7ec9f27.svg";
export { ForwardRef as ReactComponent };